// extracted by mini-css-extract-plugin
export default {"delete":"WaiveRights_delete__3QL7Z","container":"WaiveRights_container__k2vIb","delete__warning":"WaiveRights_delete__warning__PGVwP"};